
interface FetchOptions extends RequestInit {
    headers?: Record<string, string>;
}

async function customFetcher<T>(url: string, options: FetchOptions = {}): Promise<T> {
    try {
        const defaultOptions: FetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
            ...options,
        };

        const response = await fetch(url, defaultOptions);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data: T = await response.json();
        return data;
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
export default customFetcher;
